import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';
import { useEffect, useState } from 'react';

export const ToggleFilterButton = () => {
    const { t } = useTranslation();
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        toggleFilter();
    }, []);

    const toggleFilter = () => {
        let filter = document.getElementById('filter-element');
        if (filter) {
            let status = filter.hidden;
            filter.hidden = !status;
            setHidden(!status);
        }
    };

    return (
        <button className={'button--main primary-button'} onClick={toggleFilter}>
            {t(hidden ? 'common:buttons.showFilter' : 'common:buttons.hideFilter')}
        </button>
    );
};